import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import { getAdultBirthDate } from "@/utils";

interface ExplanationContent {
  title: string;
  description: string;
  buttonText: string;
}

const Explanation = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type") || "signup";

  const getExplanationContent = (type: string) => {
    switch (type) {
      case "signup":
        return {
          title: "본인인증 정보",
          description:
            "휴대폰 인증(ZKP)의 DID, 이름, 생년월일, 핸드폰 번호 데이터를 요청합니다.",
          buttonText: "인증 요청",
        };
      case "adult":
        return {
          title: "성인인증",
          description: `휴대폰 인증(ZKP)의 DID, 이름 데이터를 요청하고 생년월일을 통해 성인 여부를 확인합니다. \n\n 기준일 : ${moment().format(
            "YYYY년 MM월 DD일"
          )} \n성인 여부 조건 : 생년월일 <=${moment(
            getAdultBirthDate(18).toString()
          ).format("YYYY년 MM월 DD일")}`,
          buttonText: "인증 요청",
        };
      case "minor":
        return {
          title: "청소년인증",
          description: `휴대폰 인증(ZKP)의 DID, 이름 데이터를 요청하고 생년월일을 통해 청소년 여부를 확인합니다. \n\n 기준일 : ${moment().format(
            "YYYY년 MM월 DD일"
          )} \n청소년 여부 조건 : ${moment(
            getAdultBirthDate(18).toString()
          ).format("YYYY년 MM월 DD일")} < 생년월일 <= ${moment(
            getAdultBirthDate(9).toString()
          ).format("YYYY년 MM월 DD일")}`,
          buttonText: "인증 요청",
        };
      default:
        return {
          title: "VP SAMPLE",
          description: "Metadium DID 기반 인증 서비스를 테스트합니다.",
          buttonText: "인증 요청",
        };
    }
  };

  const content = getExplanationContent(type);

  const goTo = () => {
    navigate(`/verifier?type=${type}`);
  };

  return (
    <div className="min-h-screen flex flex-col items-center w-full h-full px-6 sm:px-[56px] bg-gray-50">
      {/* 상단 로고 */}
      <div className="mt-8 flex justify-center w-full">
        <img src={"/images/cplabs_logo.webp"} width={95} height={24} />
      </div>

      {/* 메인 컨텐츠 */}
      <div className="flex-1 flex flex-col items-center max-w-4xl mx-auto text-center mt-[108px]">
        {/* 타이틀 */}
        <h1 className="text-4xl sm:text-4xl font-bold text-gray-800 mb-12">
          {content.title}
        </h1>

        {/* 설명 텍스트 */}
        <p className="text-lg sm:text-xl text-gray-600 leading-relaxed mb-16 max-w-3xl  whitespace-pre-line">
          {content.description}
        </p>

        {/* 버튼 */}
        <button
          className="w-full sm:max-w-[280px] h-[52px] px-8 py-4 rounded-[999px] bg-[#416ab1] text-white font-medium text-lg hover:bg-[#365a9a] transition-colors"
          onClick={goTo}
        >
          {content.buttonText}
        </button>
      </div>
    </div>
  );
};

export default Explanation;
